import type { InvoiceLineKind } from '@forq/finance-data';
import type { SalesPositionKind } from '@forq/sales-data';

/**
 * Grobe Warengruppe für die Auswertung: Maschine / Ersatzteil / Dienstleistung / Sonstiges.
 * Abgeleitet aus den vorhandenen Positions-/Zeilen-Arten (kein neues Stammfeld nötig).
 */
export type Warengruppe = 'machine' | 'spare-parts' | 'service' | 'other';

export const WARENGRUPPE_ORDER: readonly Warengruppe[] = ['machine', 'spare-parts', 'service', 'other'];

export const warengruppeLabels: Readonly<Record<Warengruppe, string>> = {
  machine: 'Maschinen',
  'spare-parts': 'Ersatzteile',
  service: 'Dienstleistung',
  other: 'Sonstiges',
};

/** Rechnungszeilen-Art → Warengruppe. `material` = Ersatzteil/Ware, Arbeitswerte/Fahrt = Dienstleistung. */
export function warengruppeForInvoiceLine(kind: InvoiceLineKind): Warengruppe {
  switch (kind) {
    case 'machine': return 'machine';
    case 'material': return 'spare-parts';
    case 'labour': case 'service': case 'travel': return 'service';
    default: return 'other'; // freight, text, other
  }
}

/** Angebots-/Auftragspositions-Art → Warengruppe. `text` zählt nicht (kein Umsatz). */
export function warengruppeForSalesPosition(kind: SalesPositionKind): Warengruppe | null {
  switch (kind) {
    case 'machine': return 'machine';
    case 'article': return 'spare-parts';
    case 'service': return 'service';
    default: return null; // text
  }
}
